export enum PosthogEvent {
  USER_ONBOARDED = 'user onboarded',
  AUTH_VIA_MAGIC_LINK = 'request magic link',
  RESEND_MAGIC_LINK = 'resend magic link',
  CONTINUE_ACCOUNT_SETUP = 'continue account setup',
  APP_INSTALLED = 'app installed',
  CREATE_CHANNEL = 'create channel',
  LEAVE_CHANNEL = 'leave channel',
  PAY_SUBSCRIPTION = 'pay subscription',
  PAYMENT_ERROR = 'payment error',
  PAYMENT_SUCCESSFUL = 'payment successful',
  CREATE_CHANNEL_SUBSCRIPTION_START = 'create channel subscription / start',
  CREATE_CHANNEL_SUBSCRIPTION_STEP_1 = 'create channel subscription / complete step 1',
  CREATE_CHANNEL_SUBSCRIPTION_COMPLETE_STEP_2 = 'create channel subscription / complete step 2',
  CREATE_CHANNEL_SUBSCRIPTION_COMPLETE_STEP_3 = 'create channel subscription / complete step 3',
  CREATE_CHANNEL_SUBSCRIPTION_END = 'create channel subscription / complete',
  SHARE_CHANNEL_INVITATION_LINK = 'share channel invitation link',
  CREATE_TIP_START = 'create tip / start',
  CREATE_TIP_SUBMIT_STEP_1 = 'create tip / submit step 1',
  CREATE_TIP_SUBMIT_STEP_2 = 'create tip / submit step 2',
  CREATE_TIP_PUBLISH = 'create tip / publish tip',
  CREATE_TIP_ADD_ANOTHER = 'create tip / add another tip',
  CREATE_TIP_COMPLETE = 'create tip / complete',
  SHARE_TIP = 'share tip',
  SAVE_TIP = 'save tip',
  UNSAVE_TIP = 'unsave tip',
  VIEW_SAVED_TIP = 'view saved tips',
  UPVOTE_TIP = 'upvote tip',
  DOWNVOTE_TIP = 'downvote tip',
  VIEW_TIPSTER_PROFILE = 'view tipster profile',
  FOLLOW_TIPSTER = 'follow tipster',
  UNFOLLOW_TIPSTER = 'unfollow tipster',
  SEND_MESSAGE = 'send message',
  VIEW_ALL_MATCHES = 'view all matches',
  VIEW_MATCHE_DETAILS = 'view match details',
  VOTE = 'vote',
}